import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import FetchHook from "../../Api/FetchHooks";
import PutHooks from "../../Api/PutHook";
import { useLocation } from "react-router-dom";
import {
  formatCurrencyV2,
  formatDate,
  getKycChip,
  getUserDetails,
} from "../../utils/helpers";
import TransactionTable from "../../Components/TransactionTable";
import Page from "../../Components/Page";
import AlertComponent from "../../Components/AlertComponent";
import PageLoader from "../../Components/PageLoader";
import UseServerTable from "../../Hooks/UseServerTable";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";

const Deposits = ({ _user, showHeader = true }) => {
  const location = useLocation();
  const loggedInUser = getUserDetails();

  const [user, setUser] = useState(
    _user || location?.state?.user || loggedInUser,
  );
  const [data, setData] = useState([]);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl:
      user.role === "customer"
        ? `/transaction?type=in_wallet&entity_id=${user.id}`
        : `/transaction?type=in_wallet`,
    onSuccess: (data) => {
      setData(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  // const [loading, response, request] = FetchHook();

  // const fetchData = useCallback(async () => {
  //   try {
  //     const { page, pageSize } = paginationModel;
  //     let url = `/wallet_transaction?type=in_wallet&page_number=${
  //       page + 1
  //     }&page_size=${pageSize}`;
  //     // let url = `/wallet_transaction?type=in_wallet`;
  //     if (user.role === "customer") {
  //       url = `/wallet_transaction?type=in_wallet&entity_id="${
  //         user.id
  //       }"&page_number=${page + 1}&page_size=${pageSize}`;
  //     }
  //     await request({ url });
  //   } catch (error) {
  // const errorMessage =
  //   error.response?.data?.StatusMessage ??
  //   error.response?.data?.message ??
  //   error.message ??
  //   "An unexpected error occurred. Please try again.";

  // setSnackbar({
  //   open: true,
  //   severity: "error",
  //   message: errorMessage,
  // });
  //   }
  // }, [user, paginationModel]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   if (response && response.status === 200 && response.data.StatusCode === 0) {
  //     setData(response.data.Loan || []);
  //     setRowCount(response.data.Total || 0);
  //   }
  // }, [response]);

  const columns = [
    {
      field: "transaction_id",
      headerName: "Transaction id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "source_transaction_id",
      headerName: "Source transaction id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "account_number",
      headerName: "Account number",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "loan_id",
      headerName: "Loan id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "global_request_id",
      headerName: "Global request id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "dr_cr_pair_id",
      headerName: "Dr Cr pair",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "debit",
      headerName: "Debit (money out)",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "credit",
      headerName: "Credit (money in)",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "balance_before",
      headerName: "Balance before",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "balance_after",
      headerName: "Balance after",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 300,
      flex: 1,
    },
    {
      field: "transaction_status",
      headerName: "Status",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "transaction_settlement_time",
      headerName: "Transaction settlement time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   renderCell: (row) => (
    //     <Button
    //       variant="contained"
    //       style={{ marginLeft: 16, fontWeight: "bold" }}
    //       disabled={row.row.status === 1 ? false : true}
    //       onClick={() => fixLoanRequest(row.row)}
    //     >
    //       {fixLoading ? "Fixing..." : "Fix request"}
    //     </Button>
    //   ),
    //   width: 200,
    // },
  ];

  const custCols = [
    {
      field: "transaction_id",
      headerName: "Transaction id",
      width: 160,
    },
    {
      field: "debit",
      headerName: "Debit (money out)",
    },
    {
      field: "credit",
      headerName: "Credit (money in)",
    },
    {
      field: "balance_before",
      headerName: "Balance before",
    },
    {
      field: "balance_after",
      headerName: "Balance after",
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 300,
      flex: 1,
    },
    {
      field: "transaction_status",
      headerName: "Status",
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction time",
      width: 200,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
  ];

  const cols = [
    {
      field: "transaction_timestamp",
      headerName: "Date",
      minWidth: 170,
      flex: 1,
      valueGetter: (params) =>
        params.row.transaction_timestamp ||
        params.row.transaction_settlement_time,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "transaction_id",
      headerName: "Transaction ID",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            width: "100%",
          }}
        >
          {params.value}
        </div>
      ),
    },
    // {
    //   field: "debit",
    //   headerName: "Withdrawal",
    //   minWidth: 120,
    //   flex: 1,
    //   valueFormatter: (params) => formatCurrencyV2(params?.value),
    // },
    {
      field: "credit",
      headerName: "Deposit",
      minWidth: 120,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    // {
    //   field: "balance_after",
    //   headerName: "Balance",
    //   minWidth: 120,
    //   flex: 1,
    //   valueFormatter: (params) => formatCurrencyV2(params?.value),
    // },
    {
      field: "transaction_status",
      headerName: "Status",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => getKycChip(params?.value),
    },
  ];

  return (
    <Page title={"User Deposits"} showHeader={showHeader}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">User Deposits</Typography>
              )}
            </>
          }
        />
        <CardContent>
          {gridProps.loading ? (
            <PageLoader />
          ) : data && data.length > 0 ? (
            <TransactionTable data={data} columns={cols} {...gridProps} />
          ) : (
            <ErrorDisplay
              message="You have no deposit transactions!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default Deposits;
